export default __webpack_public_path__ + "static/media/Tempestuous Danza.accd8adb.png";